<template>
  <el-dialog
    :title="$t('common.confirm')"
    :visible.sync="dialogVisible"
    width="30%"
    @close="handleClose"
  >
    <div style="text-align:center">
      <p>{{$t('common.deleteConfirm')}}</p>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{$t('common.cancel')}}</el-button>
      <el-button type="primary" @click="deleteChainSupplier">{{$t('common.confirmDelete')}}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { deleteChainSupplier } from '@/api/admin/chainSupplier/chainSupplierApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'DeleteChainSupplier',
  data() {
    return {
      dialogVisible: false,
      deleteChainSupplierInfo: {
        csId: '',
        shopId: ''
      }
    }
  },
  methods: {
    open(chainSupplier) {
      this.dialogVisible = true
      this.deleteChainSupplierInfo = {
        csId: chainSupplier.csId,
        shopId: getShopId()
      }
    },
   async deleteChainSupplier() {
      const {code, msg} = await deleteChainSupplier(this.deleteChainSupplierInfo)
      if (code == 0) {
        this.$message.success(this.$t('common.submitSuccess'))
        this.dialogVisible = false
        this.$emit('success')
      } else {
        this.$message.error(msg)
      }
    },
    handleClose() {
      this.deleteChainSupplierInfo = {
        csId: '',
        shopId: ''
      }
    }
  }
}
</script>